import React from 'react'
import Counter from './Counter'


function SecretaryMain() {
  return (
    <div class="page-content-wrapper border">

		{/* <!-- Title --> */}
		<div class="row">
			<div class="col-12 mb-4">
				<h1 class="h3 mb-2 mb-sm-0">بيانات الشهر الحالي</h1>
			</div>
		</div>

		{/* <!-- Counter boxes START --> */}
		<Counter/>
		{/* <!-- Counter boxes END --> */}

		

	</div>
  )
}

export default SecretaryMain